
import { Component, Inject, OnInit } from '@angular/core';
import { Form, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ADMIN_IDS } from '../utils/constants';
import { AuthService } from '../auth.service';
import { EmployeeService } from '../employee/employee.service';
import { forkJoin } from 'rxjs';
import { MessagerComponent } from '../messager/messager/messager.component';
import { ScheduleService } from '../schedule/schedule.service';
import { TimeCardDialogComponent } from '../schedule/schedule/timecard-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

// First Sunday of Sun-Sat payroll (must match PAYROLL_SUNSAT_CUTOVER in backend utils.js)
const PAYROLL_SUNSAT_CUTOVER = new Date(2026, 10, 1);

interface Employee {
  id: number;
  name: string;
  type: string;
  exempt : boolean; 
}

interface WeekOption {
  value: string;
  label: string;
}

interface TimeInterval {
  hours?: number;
  minutes?: number;  
  seconds?: number;
}

interface TimeRecord {

  did: number;
  employee_id: string;
  day: string;
  daystart: string;
  dayend: string;
  lastclockout?: string;
  timehome?: TimeInterval;
  jobtime?: TimeInterval;
  pausetime?: TimeInterval;
  traveltime?: TimeInterval;
  timetofirst?: TimeInterval;
  ispaused?: boolean;
  timezone?: string;

}

@Component({
  selector: 'app-timeadjustments',
  templateUrl: './timeadjustments.component.html',
  styleUrls: ['./timeadjustments.component.css']
})
export class TimeadjustmentsComponent implements OnInit {

  originalValues : any = null;
  dirtyRows = new Set<number>(); 

  currentWeekLoaded : boolean = true;
  previousWeekLoaded : boolean = false;
  weekText : string = '(Current Week)';
  selectedApprovalRange : string = '';
  currentWeekRange : string = '';
  
  selectedEmployeeId: number | null = null;
  selectedWeek: string | null = null;

  selectedTerritoryManagerId: number | null = null;
  
  loggedInUserId: number | null = null;
  viewedUserId: number | null = null;

  employees: Employee[] = [];
  weekOptions: WeekOption[] = [];
  timeRecords: TimeRecord[] = [];
  
  timeRecordsForm: FormGroup;
  isLoading = false;
  hasUnsavedChanges = false;

  teamHoursData: any[] = [];
  isLoadingTeamHours = false;
  showTeamSummary = false;

  showReasonModal = false;
  saveReason = '';
  isValidReason = false;
  currentWeek: string = '';
  previousWeek: string = '';
  selectedApprovalWeek: string = '';
  selectedEmployee: any;
  managerStatus: any;

  approvalStates: { [employeeId: number]: boolean } = {};
  isSavingApprovals = false;
  allApproved = false;
  hasApprovalChanges = false;

  existingApprovals: { [employeeId: number]: boolean } = {};
  alreadyApprovedEmployees: Set<number> = new Set();
  isLoadingExistingApprovals = false;

  isTeamApprovalCollapsed: boolean = true;
  sumHoursThisWeek: any;

  previousDayStart: { [index: number]: string } = {};
  previousDayEnd: { [index: number]: string } = {};
  isAdjustingIntervals = false;

  weekApprovalStatus: 'not_checked' | 'approved' | 'not_approved' | 'checking' = 'not_checked';
  isWeekApproved = false;
  approvalDetails: any = null;

  supervisors: any[] = [];  
  loggedInEmployeesRegion: any;
  successMessage: string;
  showSuccessDialog: boolean;
  confirmMessage: string;
  showConfirmDialog: boolean;
  pendingApprovalData: any;

  isAdmin : boolean = false;

  employeeNoteCounts: { [employeeId: number]: number } = {};

  constructor(public formBuilder: FormBuilder, 
    public authService: AuthService, 
    public messageer: MessagerComponent,
    public employeeService: EmployeeService,
    public scheduleService: ScheduleService,
    public dialog: MatDialog
  ) {
   

    this.timeRecordsForm = this.formBuilder.group({
      records: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {


  this.authService.userProfile$.subscribe(
    (profile) => {
      let data = profile['https://rhv2.com.metadata'];
      this.managerStatus = data.role;
      this.loggedInUserId = data.id;
      this.viewedUserId = data.id;
    });

    this.employeeService.getSupervisingRaters().subscribe((data) => {
      this.supervisors = data.SupervisingRaters;
    });

    this.loadEmployees();
    this.generateWeekOptions();
    this.isAdmin = ADMIN_IDS.includes(this.loggedInUserId || -1);
    
    this.timeRecordsForm.valueChanges.subscribe(() => {
      this.hasUnsavedChanges = true;
    });

    if(this.managerStatus === 'TManager'){
      this.selectedTerritoryManagerId = this.viewedUserId;
      setTimeout(() => {
        console.log('Loading team hours for the week.');  
        this.loadTeamHoursForWeek();
      }, 3000);
    }else {
      this.selectedEmployeeId = this.loggedInUserId
    }

  }

  get recordsFormArray(): FormArray {
    return this.timeRecordsForm.get('records') as FormArray;
  }

  filterSupervisorSelection():void {
    console.log('Logged in region:', this.loggedInEmployeesRegion);
    if(this.managerStatus !== 'TManager' || ADMIN_IDS.includes(this.loggedInUserId)) return;

    this.supervisors = this.supervisors.filter(sup => sup.region.trim().toLowerCase().includes(
      this.loggedInEmployeesRegion.trim().toLowerCase()) 
      && sup.employeetype.toLowerCase().includes('manager'))
      .sort((a, b) => a.employee_name.localeCompare(b.employee_name));
    console.log('Filtered supervisors:', this.supervisors);
  }

  openDayUpdateLogs(): void {
    window.open(`/m/dayupdatelogs`, '_blank');
  }
  openTimeAdjLogs(): void {
    window.open(`/m/timeapproval`, '_blank');
  }

  openTimeCard(record): void {
            console.log(record);
            this.scheduleService.getTimecardByDate(this.selectedEmployeeId, record.day, record.timezone).subscribe(
              res => {
                let jobs = res.Data;
                console.log(res);
                console.log('Day: ', record);
                    const dialogRef = this.dialog.open(TimeCardDialogComponent, {
                      minWidth: 'dialogWidth',
                      height: 'dialogHeight',
                      data : {
                        jobs: jobs,
                        day : record,
                        employeetype : 'field',
                        from : 'timeadjustments',
                        canEditTimes: true,
                        who: this.loggedInUserId
                      },
                      panelClass: 'custom-dialog-container'
                    }).afterClosed().subscribe(result => {
                      this.onWeekChange();
                    });
              }, err => {
              })
  }

  loadEmployees(): void {

          this.employeeService.getEmployees().subscribe((employees) => {
            console.log(employees);
            this.loggedInEmployeesRegion = employees.Employees.find(emp => emp.employee_id === this.loggedInUserId)?.region || null;
            console.log('Logged in user region:', this.loggedInEmployeesRegion);

            this.filterSupervisorSelection();
            if (this.loggedInUserId ) {

              const subordinates = this.employeeService.getEmployeeTree(employees.Employees, this.viewedUserId);
              this.employees = employees.Employees.filter(emp => subordinates.includes(emp.employee_id)).map(emp => ({
                id: emp.employee_id,
                name: emp.employee_name,
                type: emp.employeetype,
                exempt : emp.exempt
              }));

              //add the logged in user to the list
              let thisEmployee = employees.Employees.find(emp => emp.employee_id == this.viewedUserId);

              if (thisEmployee) {
                this.employees.push({
                  id: this.viewedUserId,
                  name: thisEmployee.employee_name,
                  type: thisEmployee.employeetype,
                  exempt : thisEmployee.exempt
                });
              }

            } else {
              //directors/ admins get to see all emps 
                this.employees = employees.Employees.map(emp => ({
                  id: emp.employee_id,
                  name: emp.employee_name,
                  type: emp.employeetype
                })).filter(emp => emp.type && emp.type.trim() !== '')
                .filter(emp => emp.name && !emp.name.toLowerCase().includes('unassigned'));

            }
        }) 

  }

  generateWeekOptions(): void {
    const currentDate = new Date();
    const weeks: WeekOption[] = [];

    const { weekNumber: currentWeekNum, weekYear: currentWeekYear } = this.getPayrollWeekAndYear(currentDate);
    this.currentWeek = `${currentWeekYear}-W${currentWeekNum.toString().padStart(2, '0')}`;
    this.selectedApprovalWeek = this.currentWeek;
    this.currentWeekRange = this.formatWeekRange(this.currentWeek);
    this.selectedApprovalRange = this.currentWeekRange;

    // the day before this week starts, so the cutover week is never skipped
    const prevDate = this.getPayrollWeekRange(this.currentWeek).start;
    prevDate.setDate(prevDate.getDate() - 1);
    const { weekNumber: prevWeekNum, weekYear: prevWeekYear } = this.getPayrollWeekAndYear(prevDate);
    this.previousWeek = `${prevWeekYear}-W${prevWeekNum.toString().padStart(2, '0')}`;

    // Generate only weeks up to current week (year to date)
    for (let week = 1; week <= currentWeekNum; week++) {
      const weekValue = `${currentWeekYear}-W${week.toString().padStart(2, '0')}`;
      const weekLabel = `Week ${week} (${this.formatWeekRange(weekValue, true)})`;
      weeks.push({ value: weekValue, label: weekLabel });
    }

    // Reverse to show latest week first
    this.weekOptions = weeks.reverse();
  }

  // Payroll weeks run Sun-Sat and keep the ISO week number of their Monday,
  // so the payroll week containing a date is the ISO week of the following day.
  getPayrollWeekAndYear(date: Date): { weekNumber: number; weekYear: number } {
    const shifted = new Date(date);
    if (shifted >= PAYROLL_SUNSAT_CUTOVER) {
      shifted.setDate(date.getDate() + 1);
    }
    return this.getISOWeekAndYear(shifted);
  }

  formatWeekRange(week: string, withDayNames: boolean = false): string {
    const { start, end } = this.getPayrollWeekRange(week);
    const dayName = (d: Date) => ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()];
    const startText = start.toLocaleDateString();
    const endText = end.toLocaleDateString();
    return withDayNames ? `${dayName(start)} ${startText} - ${dayName(end)} ${endText}` : `${startText} - ${endText}`;
  }

  getISOWeekAndYear(date: Date): { weekNumber: number; weekYear: number } {
    // Create a copy to avoid modifying the original date
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;

    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const weekYear = d.getUTCFullYear();
    const yearStart = new Date(Date.UTC(weekYear, 0, 1));

    const weekNumber = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
    return { weekNumber, weekYear };
  }

  onTerritoryManagerChange(): void {
    this.viewedUserId = this.selectedTerritoryManagerId;
    console.log('Viewing as user ID:', this.viewedUserId);
    this.loadEmployees();
    setTimeout(() => {
      console.log('Loading team hours for the week.');  
      this.loadTeamHoursForWeek();
    }, 3000);

    this.selectedEmployeeId = null;
    this.selectedWeek = null;
    this.clearTimeRecords();
    
  }

  onEmployeeChange(): void {

    console.log('Selected employee ID:', this.selectedEmployeeId);
    console.log(this.employees);
    console.log(typeof this.selectedEmployeeId);
    this.selectedEmployee = this.selectedEmployeeId ? 
    this.employees.find(emp => emp.id === Number(this.selectedEmployeeId)) : 
    null;

    if (this.selectedEmployeeId && this.selectedWeek) {
      this.loadTimeRecords();
    } else {
      this.clearTimeRecords();
    }

    this.previousDayStart = {};
    this.previousDayEnd = {};

  }

  onWeekChange(): void {
    if (this.selectedEmployeeId && this.selectedWeek) {
      this.loadTimeRecords();
    } else {
      this.clearTimeRecords();
    }
  }

  loadTimeRecords(): void {
    if (!this.selectedEmployeeId || !this.selectedWeek) return;
    this.isLoading = true;
    this.weekApprovalStatus = 'checking';

    const timeRecordsRequest = this.employeeService.getTimeRecordsForWeek(this.selectedEmployeeId, this.selectedWeek);
    const approvalStatusRequest = this.employeeService.checkWeekApprovalStatus(this.selectedWeek, this.selectedEmployeeId);

    forkJoin({
      timeRecords: timeRecordsRequest,
      approvalStatus: approvalStatusRequest
    }).subscribe(
      (results) => {

        console.log(results);
        this.timeRecords = results.timeRecords.Records.map(record => ({
          did: record.did,                
          employee_id: record.employee_id,
          day: record.day,                
          daystart: record.daystart,      
          dayend: record.dayend,          
          pausetime: record.pausetime,    
          traveltime: record.traveltime,  
          timetofirst: record.timetofirst,
          jobtime: record.jobtime,  
          timehome: record.timehome,
          timezone: record.timezone,
          ispaused: record.ispaused || false,
          lastclockout: record.day 
        }));

        this.isWeekApproved = results.approvalStatus.IsApproved;
        this.approvalDetails = results.approvalStatus.ApprovalDetails;
        this.weekApprovalStatus = this.isWeekApproved ? 'approved' : 'not_approved';


        this.buildFormFromRecords();
        this.isLoading = false;
        this.hasUnsavedChanges = false; 

      },
      (error) => {
        console.error('Error loading time records or approval status:', error);
        this.isLoading = false;
        this.weekApprovalStatus = 'not_checked';
      });
  }

  buildFormFromRecords(): void {
    const recordsArray = this.formBuilder.array([]);
    
    this.timeRecords.forEach((record, index) => {

      const isToday = this.isCurrentDay(record);
      console.log(`Record for ${record} is today: ${isToday}`);
      const recordForm = this.formBuilder.group({

        did: [record.did],
        employee_id: [record.employee_id],
        day: [record.day],
        daystart: [this.extractTimeFromDateTime(record.daystart), Validators.required],
        dayend: [
          this.extractTimeFromDateTime(record.dayend),
          isToday ? [] : [Validators.required], //let's us edit while day is still in progress
        ],
        pausetime: [this.intervalToString(record.pausetime), Validators.required],
        traveltime: [this.intervalToString(record.traveltime), Validators.required],
        timetofirst: [this.intervalToString(record.timetofirst), Validators.required],
        jobtime: [this.intervalToString(record.jobtime)],
        timehome: [this.intervalToString(record.timehome)]

      });

      this.previousDayStart[index] = this.extractTimeFromDateTime(record.daystart);
      this.previousDayEnd[index] = this.extractTimeFromDateTime(record.dayend);

      recordForm.valueChanges.subscribe(() => {
        if (recordForm.dirty) {
          this.dirtyRows.add(index);
          this.hasUnsavedChanges = true;
        }
      });
      recordsArray.push(recordForm);
    });
    

    this.timeRecordsForm.setControl('records', recordsArray);
    this.originalValues = this.timeRecordsForm.value;
    this.dirtyRows.clear();

    this.updateFormEditableState();
  }

  onDayStartBlur(index: number): void {
      if (!this.selectedEmployee || this.isOfficeEmployee()) return;
    
      const recordForm = this.recordsFormArray.at(index);
      const newDayStart = recordForm.get('daystart')?.value;
    
      if (newDayStart && this.previousDayStart[index] && newDayStart !== this.previousDayStart[index]) {
        // visual feedback
        const inputElement = document.getElementById(`daystart-${index}`);
        if (inputElement) {
            inputElement.classList.add('adjusting');
            setTimeout(() => inputElement.classList.remove('adjusting'), 500);
        }
        
          this.handleDayStartChange(recordForm as FormGroup, index, newDayStart);
      }
  }

  onDayEndBlur(index: number): void {
      if (!this.selectedEmployee || this.isOfficeEmployee()) return;
    
      const recordForm = this.recordsFormArray.at(index);
      const newDayEnd = recordForm.get('dayend')?.value;
    
      if (newDayEnd && this.previousDayEnd[index]) {
          this.handleDayEndChange(recordForm as FormGroup, index, newDayEnd);
      }
  }

  handleDayEndChange(recordForm: FormGroup, index: number, newDayEnd: string): void {
    
      if (!newDayEnd || !this.previousDayEnd[index] || this.isAdjustingIntervals) {
          console.log('Skipping adjustment - missing data or already adjusting');
          return;
      }
    
      const previousEnd = this.previousDayEnd[index];
      const timeDifferenceMinutes = this.calculateTimeDifferenceMinutes(previousEnd, newDayEnd);
    
      if (timeDifferenceMinutes !== 0) {
          const adjustment = timeDifferenceMinutes;
        
          this.adjustTimeHome(recordForm, adjustment);
          this.previousDayEnd[index] = newDayEnd;
        
      }
  }


  handleDayStartChange(recordForm: FormGroup, index: number, newDayStart: any) {
    if (!newDayStart || !this.previousDayStart[index]) {
      return;
    }

    const previousStart = this.previousDayStart[index];
    const timeDifferenceMinutes = this.calculateTimeDifferenceMinutes(previousStart, newDayStart);

    if (timeDifferenceMinutes !== 0) {
      this.adjustTimeToFirst(recordForm, -timeDifferenceMinutes);
      this.previousDayStart[index] = newDayStart;
    }
  }

  adjustTimeToFirst(recordForm: FormGroup, adjustmentMinutes: number) {
    this.isAdjustingIntervals = true;

    const currentTimeToFirst = recordForm.get('timetofirst')?.value || '00:00:00';
    const currentMinutes = this.intervalStringToMinutes(currentTimeToFirst);

    const newMinutes = Math.max(0, Math.floor(currentMinutes + adjustmentMinutes));
    const newTimeToFirst = this.minutesToIntervalString(newMinutes);

    recordForm.get('timetofirst')?.setValue(newTimeToFirst, { emitEvent: false });

    setTimeout(() => {
      this.isAdjustingIntervals = false;
    }, 100);

  }


  adjustTimeHome(recordForm: FormGroup, adjustmentMinutes: number){
      this.isAdjustingIntervals = true;
    
      const currentTimeHome = recordForm.get('timehome')?.value || '00:00:00';
      const currentMinutes = this.intervalStringToMinutes(currentTimeHome);
    
      const newMinutes = Math.max(0, Math.floor(currentMinutes + adjustmentMinutes));
      const newTimeHome = this.minutesToIntervalString(newMinutes);

      console.log(currentTimeHome, currentMinutes, adjustmentMinutes, newMinutes, newTimeHome);
    
      recordForm.get('timehome')?.setValue(newTimeHome, { emitEvent: false });
      setTimeout(() => {
          this.isAdjustingIntervals = false;
      }, 100);
  }


  minutesToIntervalString(totalMins: number): string {
    const hours = Math.floor(totalMins / 60);
    const minutes = totalMins % 60;
    const seconds = Math.floor((totalMins % 1) * 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  }

calculateTimeDifferenceMinutes(oldTime: string, newTime: string): number {
    if (!oldTime || !newTime) return 0;
    
    console.log('Calculating difference:', { oldTime, newTime });
    
    const oldMinutes = this.timeStringToMinutes(oldTime);
    const newMinutes = this.timeStringToMinutes(newTime);
    
    console.log('Converted to minutes:', { oldMinutes, newMinutes });
    
    const difference = newMinutes - oldMinutes;
    console.log('Time difference:', difference);
    
    return difference;
}


  isOfficeEmployee(): boolean {
    return this.selectedEmployee &&
      this.selectedEmployee.type.toLowerCase().includes('office');
  }

  clearTimeRecords(): void {
    this.timeRecords = [];
    this.timeRecordsForm.setControl('records', this.formBuilder.array([]));
    this.hasUnsavedChanges = false;
  }

  trackByEmployeeId(index: number, emp: any): number {
    return emp.employeeId;
  }

  loadTeamHoursForWeek(): void {
      console.log(this.employees);

      if (this.managerStatus !== 'TManager') return;
    
      this.isLoadingTeamHours = true;
      this.isLoadingExistingApprovals = true;
      this.teamHoursData = [];
    
      let currentWeekForTeam = this.currentWeek;
      if(this.previousWeekLoaded){
        currentWeekForTeam = this.previousWeek;
      }

      const teamEmployees = this.employees.filter(emp => !emp.exempt);
    
      if (teamEmployees.length === 0) {
          this.isLoadingTeamHours = false;
          this.isLoadingExistingApprovals = false;
          return;
      }
    
      const teamHoursRequests = teamEmployees.map(employee => 
          this.employeeService.getEmployeeTimeRecordsForWeek(
              employee.id, 
              currentWeekForTeam, 
              employee.type
          )
      );

    
      const existingApprovalsRequest = this.employeeService.getExistingApprovals(
          currentWeekForTeam, 
          this.viewedUserId ?? 0
      );
    
      forkJoin({
          teamHours: forkJoin(teamHoursRequests),
          existingApprovals: existingApprovalsRequest
      }).subscribe(
          (results) => {
              this.teamHoursData = results.teamHours.map((response, index) => ({
                  employeeName: response.employee_name,
                  employeeId: response.requestedEmployee,
                  employeeType: response.employeeType,
                  totalHours: response.data?.totalHours || 0,
                  daysWorked: response.data?.daysWorked || 0,
                  firstDay: response.data?.firstDay,
                  lastDay: response.data?.lastDay,
                  weekDisplayed: currentWeekForTeam,
                  dailyBreakdown: response.data?.dailyBreakdown || []
              })).sort((a, b) => b.totalHours - a.totalHours);

              this.processExistingApprovals(results.existingApprovals);
              this.sortTeamDataByApprovalStatus();
              this.initializeApprovalStatesWithExisting();


              this.sumHoursThisWeek =  this.teamHoursData.reduce((sum, emp) => sum + (emp.totalHours || 0), 0);

            
              this.isLoadingTeamHours = false;
              this.isLoadingExistingApprovals = false;
              this.showTeamSummary = true;
              this.loadEmployeeNoteCounts(currentWeekForTeam);
          },
          (error) => {
              console.error('Error loading team data:', error);
              this.isLoadingTeamHours = false;
              this.isLoadingExistingApprovals = false;
          }
      );
  }





  loadEmployeeNoteCounts(week: string): void {
      const { start: weekStart, end: weekEnd } = this.getPayrollWeekRange(week);
      const startDate = this.toYYYYMMDD(weekStart);
      const endDate = this.toYYYYMMDD(weekEnd);

      this.employeeNoteCounts = {};
      this.teamHoursData.forEach(emp => {
          this.scheduleService.getTimecardNotesByEmployee(emp.employeeId, startDate, endDate).subscribe(
              (res) => {
                  this.employeeNoteCounts[emp.employeeId] = res.Rows || 0;
              },
              (error) => {
                  console.error('Error loading note counts for employee ' + emp.employeeId, error);
              }
          );
      });
  }

  getEmployeeNoteCount(employeeId: number): number {
      return this.employeeNoteCounts[employeeId] || 0;
  }

  viewEmployeeNotes(emp: any, event: Event): void {
      event.stopPropagation();

      const week = this.previousWeekLoaded ? this.previousWeek : this.currentWeek;
      const { start: weekStart, end: weekEnd } = this.getPayrollWeekRange(week);
      const startDate = this.toYYYYMMDD(weekStart);
      const endDate = this.toYYYYMMDD(weekEnd);

      this.scheduleService.getTimecardNotesByEmployee(emp.employeeId, startDate, endDate).subscribe(
          (res) => {
              const notes = res.Data || [];
              this.dialog.open(EmployeeNotesViewDialogComponent, {
                  width: '550px',
                  data: {
                      employeeName: emp.employeeName,
                      notes: notes,
                      week: week
                  }
              });
          },
          (error) => {
              this.messageer.openSnackBar('Error loading notes', '', 'errorAlert');
          }
      );
  }

  processExistingApprovals(existingApprovalsResponse: any): void {
      if (existingApprovalsResponse.Error) {
          console.warn('No existing approvals found or error retrieving them');
          this.alreadyApprovedEmployees.clear();
          return;
      }
    
      this.alreadyApprovedEmployees = new Set(existingApprovalsResponse.ApprovedEmployeeIds || []);
      console.log(`Found ${this.alreadyApprovedEmployees.size} already approved employees for ${this.currentWeek}`);
  }

  initializeApprovalStatesWithExisting(): void {
      this.approvalStates = {};
      this.existingApprovals = {};
    
      this.teamHoursData.forEach(emp => {
          const isAlreadyApproved = this.alreadyApprovedEmployees.has(emp.employeeId);
          this.existingApprovals[emp.employeeId] = isAlreadyApproved;
          this.approvalStates[emp.employeeId] = isAlreadyApproved; 
      });
    
      this.updateApprovalStatus();
      this.hasApprovalChanges = false; // Don't consider pre-existing approvals as changes
  }

  isEmployeeAlreadyApproved(employeeId: number): boolean {
      return this.alreadyApprovedEmployees.has(employeeId);
  }

  sortTeamDataByApprovalStatus(): void {
      this.teamHoursData.sort((a, b) => {
          const aIsApproved = this.alreadyApprovedEmployees.has(a.employeeId);
          const bIsApproved = this.alreadyApprovedEmployees.has(b.employeeId);

          if (aIsApproved !== bIsApproved) {
              return aIsApproved ? 1 : -1;
          }
          return b.totalHours - a.totalHours;
      });
  }

    onApprovalChange(employeeId: number, approved: boolean): void {
    if (this.isEmployeeAlreadyApproved(employeeId)) {
      return;
    }
  
    const wasAlreadyApproved = this.existingApprovals[employeeId];
    this.approvalStates[employeeId] = approved;
  
    if (approved !== wasAlreadyApproved) {
      this.hasApprovalChanges = true;
    } else {
      this.hasApprovalChanges = this.teamHoursData.some(emp => 
        this.approvalStates[emp.employeeId] !== this.existingApprovals[emp.employeeId]
      );
    }
  
    this.updateApprovalStatus();
  }


  onSelectAllChange(selectAll: boolean): void {
    this.teamHoursData.forEach(emp => {
      if (!this.isEmployeeAlreadyApproved(emp.employeeId)) {
        this.approvalStates[emp.employeeId] = selectAll;
      }
    });
  
    this.hasApprovalChanges = this.teamHoursData.some(emp => 
      this.approvalStates[emp.employeeId] !== this.existingApprovals[emp.employeeId]
    );
  
    this.updateApprovalStatus();
  }


  getNewApprovalCount(): number {
      return this.teamHoursData.filter(emp => 
          this.approvalStates[emp.employeeId] && !this.existingApprovals[emp.employeeId]
      ).length;
  }

  toggleTeamApprovalCollapse(): void {
    this.isTeamApprovalCollapsed = !this.isTeamApprovalCollapsed;
  }

  loadCurrentWeek(): void {
    console.log('load current week clicked');
    this.weekText = '(Current Week)';
    this.selectedApprovalWeek= this.currentWeek;
    this.selectedApprovalRange = this.formatWeekRange(this.currentWeek);
    this.currentWeekLoaded = true;
    this.previousWeekLoaded = false;
    this.loadTeamHoursForWeek();
  }

  loadPreviousWeek(): void {
    console.log('Previous week:', this.previousWeek);
    this.weekText = '(Previous Week)';
    this.selectedApprovalWeek= this.previousWeek;
    this.selectedApprovalRange = this.formatWeekRange(this.previousWeek);
    this.previousWeekLoaded = true;
    this.currentWeekLoaded = false;
    this.loadTeamHoursForWeek();
  }

  getExistingApprovalCount(): number {
      return this.teamHoursData.filter(emp => 
          this.existingApprovals[emp.employeeId]
      ).length;
  }


  getTeamTotalHours(): number {
    return this.teamHoursData.reduce((total, emp) => total + emp.totalHours, 0);
  }

  getTeamAverageHours(): number {
    if (this.teamHoursData.length === 0) return 0;
    return this.getTeamTotalHours() / this.teamHoursData.length;
  }

  extractTimeFromDateTime(dateTimeString: string): string {
      if (!dateTimeString) return '';
      const date = new Date(dateTimeString);
      return date.toLocaleTimeString('en-GB', {
        timeZone: 'America/New_York',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }); // Always display in Eastern to match database representation
  }

  intervalToString(interval: TimeInterval | undefined): string {
    if (!interval) return '00:00:00';
    
    const hours = interval.hours || 0;
    const minutes = interval.minutes || 0;
    const seconds = interval.seconds || 0;
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  stringToInterval(timeString: string): TimeInterval {
    if (!timeString || timeString === '') return { hours: 0, minutes: 0, seconds: 0 };
    
    const parts = timeString.split(':');
    if (parts.length !== 3) return { hours: 0, minutes: 0, seconds: 0 };
    
    return {
      hours: parseInt(parts[0]) || 0,
      minutes: parseInt(parts[1]) || 0,
      seconds: parseInt(parts[2]) || 0
    };
  }
  
  markAllRowsAsClean(): void {
    this.dirtyRows.clear();
    this.recordsFormArray.controls.forEach(control => {
      control.markAsPristine();
    });
  }

  onIntervalChange(controlName: string, value: string, index: number): void {
    const recordControl = this.recordsFormArray.at(index);
    recordControl.get(controlName)?.setValue(value);
  }

  getTotalPaidHours(): string{
    if (!this.recordsFormArray || this.recordsFormArray.length === 0) return '0h 0m';
  
    let totalHours = 0;
    for (let i = 0; i < this.recordsFormArray.length; i++) {
      console.log(this.recordsFormArray.at(i));
      totalHours += this.calculateTotalHours(this.recordsFormArray.at(i)).hoursFormat;
    }

    return totalHours.toFixed(2) +  'h (' + this.hourAmountToHoursAndMinutes(totalHours) + ')';
  }


  getTotalPaidHoursCurrentWeek(teamHours: any[]): number {
    if (!teamHours || teamHours.length === 0) return 0;

    let totalHours = 0;
    teamHours.reduce((sum, emp) => sum + (emp.totalHours || 0), 0);
    return totalHours;
  }
  
  calculateTotalHours(recordFormGroup: any): any{

    if (!recordFormGroup) return 0;
      const recordValue = recordFormGroup.getRawValue();
      console.log(recordValue);
  
      const startTimeStr = recordValue.daystart;
      const endTimeStr = recordValue.dayend;  
      const pauseTimeStr = recordValue.pausetime || '00:00:00';
      const travelTimeStr = recordValue.traveltime || '00:00:00';
      const timeToFirstStr = recordValue.timetofirst || '00:00:00';
      const jobTimeStr = recordValue.jobtime || '00:00:00';
      const timeHomeStr = recordValue.timehome || '00:00:00';

      if (!startTimeStr || !endTimeStr) return {
        hoursFormat: 0,
        minutesFormat: '0h 0m'
      };

      const startMinutes = this.timeStringToMinutes(startTimeStr);
      const endMinutes = this.timeStringToMinutes(endTimeStr);
      const pauseMinutes = this.intervalStringToMinutes(pauseTimeStr);
  
      if(this.selectedEmployee && this.isOfficeEmployee()){
  
        let totalMinutes = endMinutes - startMinutes - pauseMinutes;
        if (totalMinutes < 0) {
          totalMinutes += 24 * 60;
        }
        return {
          hoursFormat: Math.max(0, totalMinutes / 60),
          minutesFormat: this.formatMinutesToHours(Math.max(0, totalMinutes))
        }

      }else {
        //non office
        let baseMinutes = endMinutes - startMinutes - pauseMinutes;
        if (baseMinutes < 0) {
          baseMinutes += 24 * 60;
        }

        const timeToFirstMinutes = this.intervalStringToMinutes(timeToFirstStr);
        const timeToFirstBonus = Math.min(30, timeToFirstMinutes);

    
        const timeHomeMinutes = this.intervalStringToMinutes(timeHomeStr);
        const timeHomeBonus = Math.min(30, timeHomeMinutes);

        const totalMinutes = baseMinutes - (timeToFirstBonus + timeHomeBonus);
        //return Math.max(0, totalMinutes / 60); 

        return {
          hoursFormat: Math.max(0, totalMinutes / 60),
          minutesFormat: this.formatMinutesToHours(Math.max(0, totalMinutes))
        }
        
      }

  }

  timeStringToMinutes(timeStr: string): number {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return (hours || 0) * 60 + (minutes || 0);
  }

  hourAmountToHoursAndMinutes(hourAmount: number): string{
    return Math.floor(hourAmount) + 'h ' +  Math.floor((hourAmount % 1) * 60) + 'm';
  }

  intervalStringToMinutes(intervalStr: string): number {
    if (!intervalStr) return 0;
    const parts = intervalStr.split(':').map(Number);
    const hours = parts[0] || 0;
    const minutes = parts[1] || 0;
    const seconds = parts[2] || 0;
    return hours * 60 + minutes + (seconds / 60);
  }

  combineDateTime(dateStr: string, timeStr: string): string {
    if (!dateStr || !timeStr || timeStr.trim() === '') return null;
    // Get the date in Eastern to avoid date-shifting for users west of UTC
    const easternDate = new Date(dateStr).toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
    // Return as naive datetime string — server/PostgreSQL interprets in Eastern
    return `${easternDate}T${timeStr}:00`;
  }


  formatMinutesToHours(minutes: number): string {
    const hours = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);
    return `${hours}h ${mins}m`;
  }

  saveChanges(): void {

    const invalidDirtyRows = this.getInvalidDirtyRows();

    if (this.dirtyRows.size === 0) {
      return;
    }

    if (invalidDirtyRows.length > 0) {
      const errorMessage = this.buildValidationErrorMessage(invalidDirtyRows);
      this.messageer.openSnackBar('Cannot save: ' + errorMessage, '', 'errorAlert', 7000);
      return;
    }

    this.openReasonModal();
    
  }


  getInvalidDirtyRows(): number[] {
    return Array.from(this.dirtyRows).filter(index => {
      const recordForm = this.recordsFormArray.at(index);
      return recordForm && recordForm.invalid;
    })

  }

  buildValidationErrorMessage(invalidRows: number[]): string {
    return invalidRows.map(index => {
      const recordControl = this.recordsFormArray.at(index);
      const recordValue = recordControl.value;
      const date = new Date(recordValue.day).toLocaleDateString();
      const errors = [];

        if (recordControl.get('daystart')?.invalid) errors.push('Day Start is required');
        if (recordControl.get('dayend')?.invalid) errors.push('Day End is required');
        if (recordControl.get('pausetime')?.invalid) errors.push('Pause Time is required');
        if (recordControl.get('traveltime')?.invalid) errors.push('Travel Time is required');
        if (recordControl.get('timetofirst')?.invalid) errors.push('Time to First is required');
        
        return `Row ${index + 1} (${date}): ${errors.join(', ')}`;

    }).join('\n');

  }


  confirmSave(): void {

    if (!this.isValidReason) {
      return;
    }
    
    this.isLoading = true;
    this.showReasonModal = false;
    const formData = this.timeRecordsForm.value;


    const dirtyRecords = Array.from(this.dirtyRows).map(index => {
      const record = formData.records[index];
      const originalRecord = this.originalValues.records[index];
      const isToday = this.isCurrentDay(this.timeRecords[index]);

      return {
        did: record.did,
        employee_id: record.employee_id,
        day: record.day,
        current: {
          daystart: this.combineDateTime(record.day, record.daystart),
          dayend: record.dayend ?
           this.combineDateTime(record.day, record.dayend) :
           (isToday ? null : this.combineDateTime(record.day, record.dayend)),
          pausetime: this.stringToInterval(record.pausetime),
          traveltime: this.stringToInterval(record.traveltime),
          timetofirst: this.stringToInterval(record.timetofirst),
          jobtime: record.jobtime ? this.stringToInterval(record.jobtime) : null,
          timehome: record.timehome ? this.stringToInterval(record.timehome) : null
        },
        original: {
          daystart: this.combineDateTime(originalRecord.day, originalRecord.daystart),
          dayend: originalRecord.dayend && originalRecord.dayend.trim().length > 0 ?
          this.combineDateTime(originalRecord.day, originalRecord.dayend) : null,
          pausetime: this.stringToInterval(originalRecord.pausetime),
          traveltime: this.stringToInterval(originalRecord.traveltime),
          timetofirst: this.stringToInterval(originalRecord.timetofirst),
          jobtime: originalRecord.jobtime ? this.stringToInterval(originalRecord.jobtime) : undefined,
          timehome: originalRecord.timehome ? this.stringToInterval(originalRecord.timehome) : undefined
        }

      };
    });

    const saveObj = {
      records: dirtyRecords,
      reason: this.saveReason,
      changedRecordCount: dirtyRecords.length,
      changedRowIndices: Array.from(this.dirtyRows),
      who: this.loggedInUserId
    };
    

      this.employeeService.saveTimeRecordsForWeek(saveObj).subscribe(
        (response) => {
          console.log(response);
          this.isLoading = false;
          this.hasUnsavedChanges = false;
          this.markAllRowsAsClean();
          this.messageer.openSnackBar(response.Message, '', 'successAlert', 3000);
        }, (error) => {
          console.log(error);
          this.isLoading = false;
          this.messageer.openSnackBar(error.Message, '', 'errorAlert', 5000);
        });
  }

  // Payroll week N is the ISO week (Jan 4 is always in week 1) shifted back one day to Sun-Sat.
  // Weeks whose ISO Monday falls before the cutover stay Mon-Sun.
  getPayrollWeekRange(week: string): { start: Date; end: Date } {
    const [yearStr, weekPart] = week.split('-W');
    const jan4 = new Date(parseInt(yearStr), 0, 4);
    const start = new Date(jan4);
    start.setDate(jan4.getDate() - ((jan4.getDay() || 7) - 1) + (parseInt(weekPart) - 1) * 7);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    if (start < PAYROLL_SUNSAT_CUTOVER) {
      return { start, end };
    }
    start.setDate(start.getDate() - 1);
    end.setDate(end.getDate() - 1);
    return { start, end };
  }

  toYYYYMMDD(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  openReasonModal(): void {
    this.showReasonModal = true;
    this.saveReason = '';
    this.isValidReason = false;
  }

  closeReasonModal(): void {
    this.showReasonModal = false;
    this.saveReason = '';
    this.isValidReason = false;
  }

  onReasonChange(event: any): void {
    this.saveReason = event.target.value.trim();
    this.isValidReason = this.saveReason.length >= 5;
  }

  getDirtyRecordCount(): number {
    return this.dirtyRows.size;
  }

  isWeekEditable(): boolean {

    // Payroll week ends Saturday; the previous week stays editable through Sunday and Monday
    const isGraceDay = [0, 1].includes(new Date().getDay());

    const isCurrentWeek = (this.selectedWeek === this.currentWeek || (this.selectedWeek === this.previousWeek && isGraceDay));
    //if (this.managerStatus === 'TManager' && isCurrentWeek) {
        //return true;
    //}

    return isCurrentWeek && !this.isWeekApproved;
  }


initializeApprovalStates(): void {
  this.approvalStates = {};
  this.teamHoursData.forEach(emp => {
    this.approvalStates[emp.employeeId] = false;
  });
  this.updateApprovalStatus();
}

updateApprovalStatus(): void {
  this.allApproved = this.isAllSelected();
}

isManagerEditMode(): boolean {
    return this.managerStatus === 'TManager' && this.selectedWeek === this.currentWeek;
}

getDisabledMessage(): string {
    if (!this.selectedWeek) return '';
    
    const isCurrentWeek = this.selectedWeek === this.currentWeek;
    const isManager = this.managerStatus === 'TManager';
    
    if (!isCurrentWeek) {
        return 'Only the current week can be edited';
    }

    if (this.isWeekApproved && !isManager) {
        return `Week has been approved by ${this.approvalDetails?.approved_by_name || 'manager'} and cannot be edited`;
    }
    
    if (this.isWeekApproved && isManager) {
        return `Week approved by ${this.approvalDetails?.approved_by_name || 'manager'}`;
    }
    
    return '';
}



getApprovedCount(): number {
  return Object.values(this.approvalStates).filter(Boolean).length;
}

isAllSelected(): boolean {
  if (this.teamHoursData.length === 0) return false;
  return this.teamHoursData.every(emp => this.approvalStates[emp.employeeId]);
}

isPartiallySelected(): boolean {
  if (this.teamHoursData.length === 0) return false;
  const selectedCount = this.getApprovedCount();
  return selectedCount > 0 && selectedCount < this.teamHoursData.length;
}


saveApprovals(): void {
    const newlyApprovedEmployees = this.teamHoursData.filter(emp => 
        this.approvalStates[emp.employeeId] && !this.existingApprovals[emp.employeeId]
    );
    
    const allSelectedEmployees = this.teamHoursData.filter(emp => 
        this.approvalStates[emp.employeeId]
    );
    
    if (allSelectedEmployees.length === 0) {
        
        this.messageer.openSnackBar('Please select at least one employee to approve.', '', 'errorAlert', 5000);
        return;
    }
    
    if (newlyApprovedEmployees.length === 0) {
        this.messageer.openSnackBar('All selected employees have already been approved for this week.', '', 'errorAlert', 5000);
        return;
    }
    
    const alreadyApprovedCount = allSelectedEmployees.length - newlyApprovedEmployees.length;
    
    if (alreadyApprovedCount > 0) {
        this.confirmMessage = `${newlyApprovedEmployees.length} employees will be newly approved. ` +
            `${alreadyApprovedCount} employees are already approved. Continue?`;
        this.pendingApprovalData = {
            newlyApprovedEmployees,
            allSelectedEmployees,
            approvalData: {
                week: this.selectedApprovalWeek,
                approvedBy: this.loggedInUserId,
                approvals: allSelectedEmployees.map(emp => ({
                    employeeId: emp.employeeId,
                    employeeName: emp.employeeName,
                    totalHours: emp.totalHours,
                    daysWorked: emp.daysWorked,
                    employeeType: emp.employeeType
                }))
            }
        };
        this.showConfirmDialog = true;
        return;
    }
    this.executeApprovals(newlyApprovedEmployees, allSelectedEmployees);
}

showSuccessModal(message: string): void {
    this.successMessage = message;
    this.showSuccessDialog = true;
}

hideSuccessModal(): void {
    this.showSuccessDialog = false;
    this.successMessage = '';
}

hideConfirmModal(): void {
    this.showConfirmDialog = false;
    this.confirmMessage = '';
    this.pendingApprovalData = null;
}

getCurrentDateString(): string {
    const today = new Date();
    return today.toISOString().split('T')[0] + 'T04:00:00.000Z';
}

isCurrentDay(record: any): boolean {
  if(!record || !record.day) return false;

  const recordDate = new Date(record.day);
  const today = new Date();

  return (
    recordDate.getFullYear() === today.getFullYear() &&
    recordDate.getMonth() === today.getMonth() &&
    recordDate.getDate() === today.getDate()
  );

}

proceedWithApprovals(): void {
    this.showConfirmDialog = false;

    if (this.pendingApprovalData) {
        this.executeApprovals(
            this.pendingApprovalData.newlyApprovedEmployees,
            this.pendingApprovalData.allSelectedEmployees
        );
        this.pendingApprovalData = null;
    }
}

executeApprovals(newlyApprovedEmployees: any[], allSelectedEmployees: any[]): void {
    this.isSavingApprovals = true;
    const approvalData = {
        week: this.selectedApprovalWeek,
        approvedBy: this.loggedInUserId,
        approvals: allSelectedEmployees.map(emp => ({
            employeeId: emp.employeeId,
            employeeName: emp.employeeName,
            totalHours: emp.totalHours,
            daysWorked: emp.daysWorked,
            employeeType: emp.employeeType
        }))
    };

    this.employeeService.saveTimeApprovals(approvalData).subscribe(
        (response) => {
            this.isSavingApprovals = false;
            this.hasApprovalChanges = false;

            newlyApprovedEmployees.forEach(emp => {
                this.alreadyApprovedEmployees.add(emp.employeeId);
                this.existingApprovals[emp.employeeId] = true;
            });

            const newCount = response.SuccessCount || newlyApprovedEmployees.length;
            const alreadyApprovedCount = allSelectedEmployees.length - newlyApprovedEmployees.length;
            const alreadyCount = response.AlreadyApprovedCount || alreadyApprovedCount;

            let message = `Successfully approved ${newCount} new employee(s)`;
            if (alreadyCount > 0) {
                message += ` (${alreadyCount} were already approved)`;
            }
            message += ` for ${this.selectedApprovalWeek}`;
            this.showSuccessModal(message);
            this.onEmployeeChange();

            if (response.Results) {
                console.log('Approval results:', response.Results);
            }
        },
        (error) => {
            this.isSavingApprovals = false;
            console.error('Error saving approvals:', error);
            alert('Error saving approvals. Please try again.');
        }
    );
}

  updateFormEditableState(): void {
    const isEditable = this.isWeekEditable();
  
    this.recordsFormArray.controls.forEach(control => {
      const editableFields = ['daystart', 'dayend', 'pausetime', 'traveltime', 'timetofirst', 'jobtime', 'timehome'];
    
      editableFields.forEach(field => {
        const formControl = control.get(field);
        if (formControl) {
          if (isEditable) {
            formControl.enable();  
          } else {
            formControl.disable(); 
          }
        }
      });
    });
  }

}

@Component({
  template: `
    <h2 mat-dialog-title style="color: #424242; font-family: Roboto; margin: 0; padding: 16px 24px; background: white;">
      Notes for {{ data.employeeName }}
    </h2>
    <div mat-dialog-content style="padding: 0 24px; background: white; max-height: 400px; overflow-y: auto;">
      <div *ngIf="data.notes.length === 0" style="color: #8a8a8a; padding: 20px 0; font-style: italic;">
        No notes for this week.
      </div>
      <div *ngFor="let n of data.notes" style="padding: 10px 0; border-bottom: 1px solid #eee;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start;">
          <span style="color: #424242; flex: 1; word-break: break-word; font-size: 14px;">{{ n.note }}</span>
        </div>
        <div style="margin-top: 4px; display: flex; gap: 12px;">
          <span style="color: #8a8a8a; font-size: 12px;">{{ n.day?.substring(0,10) }}</span>
          <span *ngIf="n.created_by" style="color: #8a8a8a; font-size: 12px;">by {{ n.created_by }}</span>
          <span *ngIf="n.job_id" style="color: #477333; font-size: 12px;">{{ n.street_address }} - {{ n.customer_jobtype }}</span>
          <span *ngIf="!n.job_id" style="color: #8a8a8a; font-size: 12px; font-style: italic;">General</span>
        </div>
      </div>
    </div>
    <div mat-dialog-actions style="justify-content: flex-end; padding: 8px 24px; background: white;">
      <button mat-button (click)="dialogRef.close()" style="color: #666;">Close</button>
    </div>
  `
})
export class EmployeeNotesViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EmployeeNotesViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
